<template>
    <component :is="option.attribute.decorationType" :key="refreshFlagKey" :color="[option.attribute.color1, option.attribute.color2]"
               :style="{width:width+'px',height:height+'px',color: option.attribute.textColor}">{{ option.attribute.text }}
    </component>
</template>

<script>
export default {
    name: "cpt-dataV-decoration",
    props: {
        width: Number,
        height: Number,
        option: Object
    },
    watch: {
        option: {
            handler() {
                this.refreshFlagKey = require('uuid').v1();//强制刷新视图
            },
            deep: true//深度监听
        },
        width() {
            this.refreshFlagKey = require('uuid').v1();
        }
    },
    data() {
        return {
            refreshFlagKey: require('uuid').v1()
        }
    }
}
</script>

<style scoped>

</style>
